import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchDigitalResourceTypesThunk: any = createAsyncThunk<IBindBaseEntity[]>(
  `${prefix} fetchDigitalResourceTypes`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getDigitalResourcesTypes();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch digital resource types. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
